import { FileExtension, FileType, SuretyBondFormType, UploadedFile } from "@inrev/common";

export enum NameSuffix {
	JR = "JR",
	III = "III",
	IV = "IV",
	V = "V",
}

// removes the admin flag from being able to be set by the client
export type UploadFile<
	TAllowedFileType extends FileType = FileType,
	TAllowedExtension extends FileExtension = FileExtension,
> = Omit<UploadedFile<TAllowedFileType, TAllowedExtension>, "typesConfirmedByAdmin">;

export type BondFormData = {
	templateId: string | "";
	upload: {
		type: SuretyBondFormType | "";
		files: UploadFile<typeof FileType.blank_bond_form>[];
	};
};

export type LocallyUploadedFile<
	TAllowedFileType extends FileType = FileType,
	TAllowedExtension extends FileExtension = FileExtension,
> = UploadFile<TAllowedFileType, TAllowedExtension>;
export type EntityArrayLocation = { newOrExisting: "new" | "existing"; index: number };
